export default __webpack_public_path__ + "static/media/bbag2.e7f5eb5a.jpg";